import { Modal } from '@perch-labs/shrike';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  [data-reach-dialog-content] {
    padding: 0px;
    margin: 0 auto;
    max-width: 640px;
    max-height: 90vh;
  }
`;
